import digitalData from 'digital-data';
import { getState } from '../analytics-state';
import { STASH, NOT_APPLICABLE, PACKAGES_PIP } from '../constants';

const eventOriginatedFromProductPodOrFbt = (path) => {
  return (path || [])
    .reverse()
    .find((name) => name.match(/productpod\[/i) || name.match(/frequentlyboughttogether\[/i));
};

const eventOriginatedFromPromotionProducts = (path) => {
  return !!(path || []).find((name) => name.match(/promotionproducts/i));
};

export const getSectionFromPath = ({ path = [] }) => {
  const buyBoxRE = /buybox/i;
  const isFromBuyBox = path.find((part = '') => buyBoxRE.test(part));
  if (eventOriginatedFromPromotionProducts(path)) {
    return 'module';
  }
  if (isFromBuyBox) {
    return 'buybox';
  }
  return 'unknown';
};

export const getTargetFromPath = ({ path }) => {
  const lowerCasePath = path.map((name) => (name || '').toLowerCase());
  const atcIndex = lowerCasePath.findIndex((part) => /^addtocart/i.test(part));
  if (atcIndex > -1) {
    return 'atc';
  }

  return '';
};

const isFromPackagePage = (path = []) => {
  const packagePageRE = /packagepage/i;
  const packageMiniRE = /packagesmini/i;
  const isFromPackagePageOrPackageMini = path.find((part = '') => {
    return (packagePageRE.test(part) || packageMiniRE.test(part));
  });
  return !!isFromPackagePageOrPackageMini;
};

const getItemsFromCartReqParams = (cartReqParams, path) => {
  const state = getState();
  const recommendation = {
    recommendationType: 'kitchen package',
    pageType: state?.pageType,
    displayPosition: NOT_APPLICABLE,
    strategy: NOT_APPLICABLE,
    recommendationVersion: NOT_APPLICABLE,
    featureVersion: NOT_APPLICABLE
  };

  if (Array.isArray(cartReqParams)) {
    if (isFromPackagePage(path)) {
      return cartReqParams.map(({ itemId, displayPosition = NOT_APPLICABLE }) => (
        {
          productInfo: {
            sku: itemId,
          },
          displayPosition,
          recommendation
        }
      ));
    }
    return cartReqParams.map(({ itemId, displayPosition }) => (
      {
        productInfo: {
          sku: itemId,
        },
        displayPosition,
      }
    ));
  }
  return [{ productID: cartReqParams?.itemId, index: '' }];
};

export const addToCartAnalytics = () => {

  window.LIFE_CYCLE_EVENT_BUS.on('@@ADD-TO-CART/LOCATION', (payload) => {
    if (window.isDebugMode) {
      console.log('%c @@ADD-TO-CART/LOCATION is deprecated.', 'background: red; color: black', payload);
    }
  });

  // @todo logic for dpd atc click
  // https://github.homedepot.com/thd-olt-component/hdhome-analytics/blob/master/events/dpd.js#L35

  window.LIFE_CYCLE_EVENT_BUS.on('cart.add-to-cart', ({ output }) => {
    const {
      cartReqParams,
      cartOptions,
      path = []
    } = output;

    if (eventOriginatedFromProductPodOrFbt(path) && !eventOriginatedFromPromotionProducts(path)) return;

    const { pageType = '' } = getState() || {};
    const section = getSectionFromPath({ path });
    const target = getTargetFromPath({ path });
    const items = getItemsFromCartReqParams(cartReqParams, path);
    const eventName = Array.isArray(cartReqParams) ? 'cart addition info' : 'cart add location';
    const sharedSection = cartOptions?.sharedSection || 'n/a';
    const component = cartOptions?.component || '';

    const ddoStashEvent = {
      eventInfo: {
        eventName
      },
      category: {
        primaryCategory: STASH
      },
      eventMode: STASH,
      stash: {
        component,
        item: items,
        pageType,
        section,
        sharedSection,
        target
      }
    };

    (digitalData?.event || []).push(ddoStashEvent);
  });
};
